export function isEmpty(value) {
	return value == null || value == undefined || value == "";
}
